import React, { useState } from 'react';
import api from '../api';

const SUBSCRIPTION_FEATURES = [
  { id: 'daily_quotes', name: 'Daily Quotes' },
  { id: 'news', name: 'News' },
  { id: 'announcements', name: 'Announcements' },
  { id: 'event_updates', name: 'Event Updates' },
  { id: 'newsletters', name: 'Newsletters' },
];

const SubscriptionForm = ({ preloadedEmail = '', preloadedName = '', isLoggedIn = false }) => {
  const [email, setEmail] = useState(preloadedEmail);
  const [fullName, setFullName] = useState(preloadedName);
  const [phone, setPhone] = useState('');
  const [selectedFeatures, setSelectedFeatures] = useState(
    SUBSCRIPTION_FEATURES.map(f => f.id)
  );
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });
    try {
      const response = await api.post('/api/subscriptions', {
        email: email,
        full_name: fullName,
        phone: phone,
        features: selectedFeatures.length > 0 ? selectedFeatures : null,
      });
      setMessage({ type: 'success', text: 'Subscription updated successfully!' });
    } catch (error) {
      setMessage({ type: 'error', text: 'Failed to save subscription. Please try again.' });
    } finally {
      setLoading(false);
    }
  };

  const handleUnsubscribeAll = async () => {
    if (!email) {
      setMessage({ type: 'error', text: 'Please enter your email first.' });
      return;
    }
    setLoading(true);
    setMessage({ type: '', text: '' });
    try {
      await api.delete(`/api/subscriptions/${encodeURIComponent(email)}`);
      setSelectedFeatures([]);
      setMessage({ type: 'success', text: 'Unsubscribed from all features.' });
    } catch (error) {
      setMessage({ type: 'error', text: 'Failed to unsubscribe. Please try again.' });
    } finally {
      setLoading(false);
    }
  };

  const handleCheckboxChange = (featureId) => {
    setSelectedFeatures(prev => prev.includes(featureId) ? prev.filter(f => f !== featureId) : [...prev, featureId]);
  };

  return (
    <div className="subscription-form">
      <h2>{isLoggedIn ? 'Update Subscription' : 'Email Subscription'}</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={isLoggedIn}
          />
        </div>
        {isLoggedIn && (
          <div className="form-group">
            <label htmlFor="fullName">Full Name</label>
            <input
              id="fullName"
              type="text"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              disabled={isLoggedIn}
            />
          </div>
        )}
        <div className="form-group">
          <label htmlFor="phone">Phone (optional)</label>
          <input
            id="phone"
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="123-456-7890"
          />
        </div>
        <fieldset>
          <legend>Choose what to receive:</legend>
          {SUBSCRIPTION_FEATURES.map((feature) => (
            <label key={feature.id} className="feature-item">
              <input
                type="checkbox"
                id={`feature-${feature.id}`}
                checked={selectedFeatures.includes(feature.id)}
                onChange={() => handleCheckboxChange(feature.id)}
                aria-label={feature.name}
              />
              <span>
                <div className="feature-name">{feature.name}</div>
              </span>
            </label>
          ))}
        </fieldset>
        <div className="form-actions">
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {isLoggedIn ? 'Update' : 'Subscribe'}
          </button>
          {isLoggedIn && (
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleUnsubscribeAll}
              disabled={loading}
            >
              Unsubscribe from all
            </button>
          )}
        </div>
        {message.text && (
          <p className={`form-message ${message.type === 'error' ? 'form-error' : ''}`}>
            {message.text}
          </p>
        )}
      </form>
    </div>
  );
};

export default SubscriptionForm;